import React, { useMemo } from 'react';
import { number } from 'prop-types';
import Skeleton from 'react-loading-skeleton';

const TradeShowsListingLoader = ({ count = 3 }) => {
    const skeletonItems = useMemo(() => {
        const items = [];

        if (!count) {
            return items;
        }

        for (let i = 0; i < count; i += 1) {
            items.push(
                <div className="skeleton-loader-row" key={i}>
                    <div className="grid">
                        <div className="col-sm-3">
                            <Skeleton
                                className="skeleton-rect"
                                height={130}
                                style={{
                                    marginBottom: 20
                                }}
                            />
                        </div>
                        <div className="col-sm-9">
                            <Skeleton
                                height={18}
                                width="90%"
                                style={{
                                    marginBottom: 25
                                }}
                            />
                            <Skeleton
                                height={10}
                                style={{
                                    marginBottom: 8
                                }}
                            />
                            <Skeleton
                                height={10}
                                style={{
                                    marginBottom: 8
                                }}
                            />
                            <Skeleton
                                height={10}
                                width="80%"
                                style={{
                                    marginBottom: 30
                                }}
                            />
                            <div className="skeleton-flex-container">
                                <Skeleton height={10} width={80} />
                                <Skeleton height={10} width={80} />
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        return items;
    }, []);

    return <React.Fragment>{skeletonItems.map(item => item)}</React.Fragment>;
};

TradeShowsListingLoader.propTypes = {
    count: number
};

export default TradeShowsListingLoader;
